import { extractByTypename } from '@local/utils'

import { TimelineTab } from '@web/federation/gql/graphql'
import { useGoTo } from '@web/hooks/useGoTo'
import routes from '@web/libs/constants/routes'
import { UPCOMING_PAGE_SIZE } from '@web/pages/timeline/components/TimelineUpcoming'
import { UPCOMING_SECTION_TAB } from '@web/pages/v5/home/UpcomingSection'
import { useUpcomingBooking } from '@web/pages/v5/home/UpcomingSection/hooks/useUpcomingBooking'
import { useUpcomingOrder } from '@web/pages/v5/home/UpcomingSection/hooks/useUpcomingOrder'
import { useUpcomingTrainTicket } from '@web/pages/v5/home/UpcomingSection/hooks/useUpcomingTrainTicket'

export const useUpcomingMore = () => {
  const { upcomingBookingFetchMore } = useUpcomingBooking({ limit: UPCOMING_PAGE_SIZE })
  const { upcomingOrderFetchMore } = useUpcomingOrder({ limit: UPCOMING_PAGE_SIZE })
  const { upcomingTrainTicketFetchMore } = useUpcomingTrainTicket({ limit: UPCOMING_PAGE_SIZE })
  const { goTo } = useGoTo()

  const upcomingMore = async ({
    upcomingSectionTab,
    anchor,
    replace,
  }: {
    upcomingSectionTab: UPCOMING_SECTION_TAB
    anchor?: boolean
    replace?: boolean
  }) => {
    const { tab, upcomingAnchorId } = await (async () => {
      if (upcomingSectionTab === UPCOMING_SECTION_TAB.BOOKING) {
        let upcomingAnchorId

        if (anchor) {
          const moreItems = await upcomingBookingFetchMore()
          if (moreItems) {
            upcomingAnchorId = extractByTypename(moreItems.data.me).MeSucceed?.upcomingBookings?.bookings?.[0].id
          }
        }

        return {
          tab: TimelineTab.Reservation,
          upcomingAnchorId,
        }
      }

      if (upcomingSectionTab === UPCOMING_SECTION_TAB.ORDER) {
        let upcomingAnchorId

        if (anchor) {
          const moreItems = await upcomingOrderFetchMore()
          if (moreItems) {
            upcomingAnchorId = extractByTypename(moreItems.data.me).MeSucceed?.upcomingOrders?.orders?.[0].id
          }
        }

        return {
          tab: TimelineTab.Order,
          upcomingAnchorId,
        }
      }

      if (upcomingSectionTab === UPCOMING_SECTION_TAB.TRAIN_TICKET) {
        let upcomingAnchorId
        if (anchor) {
          const moreItems = await upcomingTrainTicketFetchMore()

          if (moreItems) {
            upcomingAnchorId = extractByTypename(moreItems.data.me).MeSucceed?.upcomingTrainTickets?.edges?.[0].node.id
          }
        }

        return {
          tab: TimelineTab.TrainTicket,
          upcomingAnchorId,
        }
      }

      return { tab: TimelineTab.All }
    })()

    goTo(routes.TIMELINE_LIST, {
      query: { tab, view: 'full', ...(upcomingAnchorId && { upcomingAnchor: upcomingAnchorId }) },
      replace,
    })
  }

  return {
    upcomingMore,
  }
}
